import {useEffect, useMemo, useState} from 'react'
import _ from 'lodash'
import {camelToSnake, alwaysArray} from '@eitje/utils'
import {navigate, t, useLocation} from '@eitje/bridge'
import {notifications} from '~/components/notification'
import {MultiActionBar} from '../multi_action_bar'
import {MultiActionContext} from './multi_action_context'

const MAX_ACTION_AMOUNT = 200
const {Provider} = MultiActionContext

export const MultiActionProvider = ({Model, DropdownItems, children}) => {
	const [multiActionActive, setMultiActionActive] = useState(false)
	const [multiActionIds, setMultiActionIds] = useState([])
	const location = useLocation()

	const toggleMultiActionIds = changeIds => {
		const incomingChange = alwaysArray(changeIds)

		const isRemoving = incomingChange.every(id => multiActionIds.includes(id))

		if (isRemoving) {
			setMultiActionIds(_.difference(multiActionIds, incomingChange))
		} else {
			const newIds = [...multiActionIds, ...incomingChange].uniq()

			if (newIds.length > MAX_ACTION_AMOUNT) return notifications.errNotif(t('notifs.max_amount_notif', {count: MAX_ACTION_AMOUNT}))

			setMultiActionIds(newIds)
		}
	}

	const resetMultiAction = () => {
		setMultiActionActive(false)
		setMultiActionIds([])
	}

	const modelKey = camelToSnake(Model.tableName)
	const {pathname, search} = location
	const locationState = location.state
	const multiActionReset = locationState?.multiActionReset

	useEffect(() => {
		if (!locationState?.multiActionReset) return

		resetMultiAction()

		const state = {...locationState}
		delete state.multiActionReset

		navigate(`${pathname}${search || ''}`, {replace: true, state})
	}, [locationState, multiActionReset, pathname, search])

	const value = useMemo(
		() => ({
			Model,
			modelKey,
			multiActionActive,
			setMultiActionActive,
			multiActionIds,
			toggleMultiActionIds,
			setMultiActionIds,
			resetMultiAction,
		}),
		[multiActionActive, multiActionIds],
	)

	return (
		<Provider value={value}>
			{children}
			<MultiActionBar DropdownItems={DropdownItems} />
		</Provider>
	)
}
